module.exports = __webpack_public_path__ + "static/media/au.503a3a98.svg";